import { createSlice } from "@reduxjs/toolkit";
import { locationAction, locationOptionsAction } from "redux/action/locationAction";


const initialState = {
    isLoading: false,
    data: [],
    error: null,
    optionData: [],
    isOptionLoading: false,
    optionError: null,
};

const locationSlice = createSlice({
    initialState,
    name: 'location',
    reducers: {
        resetLocationOptions: (state) => {
            state.data = [];
            state.optionData = [];
            state.error = null;
            state.optionError = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(locationAction.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(locationAction.fulfilled, (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
        });
        builder.addCase(locationAction.rejected, (state, action: any) => {
            state.error = action.payload;
            state.isLoading = false;
        });
        builder.addCase(locationOptionsAction.pending, (state) => {
            state.isOptionLoading = true;
        });
        builder.addCase(locationOptionsAction.fulfilled, (state, action) => {
            state.optionData = action.payload;
            state.isOptionLoading = false;
        });
        builder.addCase(locationOptionsAction.rejected, (state, action: any) => {
            state.optionError = action.error;
            state.isOptionLoading = false;
        });
    },
});

export const { resetLocationOptions } = locationSlice.actions;
export default locationSlice;